import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { KeyValue } from "../models/key-value";

const useAsyncSelectFormInput = (
  loadItems: () => Promise<KeyValue<string>[]>,
  placeholder: string
) => {
  const intl = useIntl();
  const loadingPlaceholder = intl.messages["GLOBAL.LOADING"] as string;

  const [selectPlaceholder, setPlaceholder] = useState(
    `${loadingPlaceholder}...`
  );
  const [selectItems, setItems] = useState<KeyValue<string>[]>([]);

  useEffect(() => {
    if (!loadItems) {
      return;
    }
    (async () => {
      const loadedItems = await loadItems();
      if (!loadedItems) return;

      setItems(loadedItems);
      setPlaceholder(placeholder ?? "Select");
    })();
  }, [loadItems, placeholder]);

  return { selectItems, selectPlaceholder };
};

export default useAsyncSelectFormInput;
